var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('abbr',{staticClass:"required-asterisk",attrs:{"title":"required","aria-hidden":"true"}},[_vm._v("*")])
}
var staticRenderFns = []

export { render, staticRenderFns }